// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MethodArgument } from './MethodArgument';
import {
    MethodArgumentFromJSON,
    MethodArgumentFromJSONTyped,
    MethodArgumentToJSON,
    MethodArgumentToJSONTyped,
} from './MethodArgument';

/**
 * A reconstructed, callable OPC UA method on a device
 * @export
 * @interface MethodInfo
 */
export interface MethodInfo {
    /**
     * Full OPC UA browse path of the method (use it for /control-call)
     * @type {string}
     * @memberof MethodInfo
     */
    browsePath: string;
    /**
     * 
     * @type {string}
     * @memberof MethodInfo
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MethodInfo
     */
    displayName?: string;
    /**
     * 
     * @type {Array<MethodArgument>}
     * @memberof MethodInfo
     */
    inputArguments?: Array<MethodArgument>;
    /**
     * 
     * @type {Array<MethodArgument>}
     * @memberof MethodInfo
     */
    outputArguments?: Array<MethodArgument>;
}

/**
 * Check if a given object implements the MethodInfo interface.
 */
export function instanceOfMethodInfo(value: object): value is MethodInfo {
    if (!('browsePath' in value) || value['browsePath'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function MethodInfoFromJSON(json: any): MethodInfo {
    return MethodInfoFromJSONTyped(json, false);
}

export function MethodInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MethodInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'browsePath': json['browsePath'],
        'name': json['name'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'inputArguments': json['inputArguments'] == null ? undefined : ((json['inputArguments'] as Array<any>).map(MethodArgumentFromJSON)),
        'outputArguments': json['outputArguments'] == null ? undefined : ((json['outputArguments'] as Array<any>).map(MethodArgumentFromJSON)),
    };
}

export function MethodInfoToJSON(json: any): MethodInfo {
    return MethodInfoToJSONTyped(json, false);
}

export function MethodInfoToJSONTyped(value?: MethodInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'browsePath': value['browsePath'],
        'name': value['name'],
        'displayName': value['displayName'],
        'inputArguments': value['inputArguments'] == null ? undefined : ((value['inputArguments'] as Array<any>).map(MethodArgumentToJSON)),
        'outputArguments': value['outputArguments'] == null ? undefined : ((value['outputArguments'] as Array<any>).map(MethodArgumentToJSON)),
    };
}

